import React from 'react';
import Step from './Step';
import Login from '../hooks/useLogin';
import BmiCookieConsent from './BmiCookieConsent';
import { CreateDotaznik } from '../hooks/createDotaznik';
import { t } from '../i18n';
import axios from '../api/axios';
import BG_IMG_CLOUDS from "../assets/img/bg_img_clouds.png";
import BG_IMG_PLANE from "../assets/img/bg_img_plane.png";
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBSwitch,
    MDBBtn,
    MDBValidationItem,
    MDBAccordion,
    MDBAccordionItem,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

const stepsJson = process.env.REACT_APP_LANG === 'sk'
    ? require('../assets/sk/steps.json')
    : require('../assets/cz/steps.json');

const dotaznikJson = process.env.REACT_APP_LANG === 'sk'
    ? require('../assets/sk/dotaznik.json')
    : require('../assets/cz/dotaznik.json');


const CONSTANTS = {
    FIRST_PAGE_SWITCH_TEXT_CLASSES: "d-grid align-items-end px-3 mb-4 mt-3 user-select-none pointer switch-text",
}



class PriceCalculatorForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            files: [],
            dotaznik: dotaznikJson,
            dotaznikValid: false,
            dotaznikCreated: false,

            roofCalculation: true,
            isolation: false,
            documentation: false,
            noDocumentation: false,
            buildingExists: false,
            extensions: false,
            gdprConsent: false,

            steps: stepsJson,
            activeItems: [3, 7],
            activeStep: 1,

            selectedCoveringColor: "cerna",

            noDocumentationModal: false,
            noBuildingModal: false,
            gdprModal: false,
            confirmationModal: false,
            loadingModal: false,
            loadingModalTitle: t("loading_title"),
            loadingModalText: "",

            config: {},
        };
        this.stateHandler = this.stateHandler.bind(this);
        this.dotaznikCreateHandler = this.dotaznikCreateHandler.bind(this);
    }

    componentDidMount() {
        axios.get('cenovanabidka/config?org=' + process.env.REACT_APP_ORG)
            .then(r => this.setState({ config: r.data }))
            .catch(() => {});
    }

    handleDocumentation(e) {
        if (e.target.id === "HaveDocumentation" && e.target.checked) {
            if (this.state.noDocumentation) {
                document.getElementById('DontHaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && e.target.checked) {
            if (this.state.documentation) {
                document.getElementById('HaveDocumentation').click();
            }
        } else if (e.target.id === "DontHaveDocumentation" && !e.target.checked) {
            this.setState({ buildingExists: false })
        }
        let stepContact = this.getStep(7);
        stepContact.showMap = this.state.noDocumentation;
    }

    stepsControl() {
        let stepsArray = this.state.steps;
        stepsArray.forEach(step => {
            if (step.state != "") {
                let value = this.state[step.state];
                step.visible = value;
            }
            if (step.number == 7) {
                step.showMap = this.state.noDocumentation;
            }
            step.visibleClass = (step.visible) ? "" : "d-none";
        })
    }

    stateHandler(name, value) {
        if (name === 'extensions') {
            this.setState({ ...this.state, [name]: value }, () => this.accordionHandler([3, 4]));
        } else if (name === 'isolation') {
            this.setState({ ...this.state, [name]: value });
        } else {
            this.setState({ ...this.state, [name]: value });
        }
    }

    toggleNoDocModal() {
        if (this.state.noDocumentation) {
            this.setState({ noDocumentationModal: !this.state.noDocumentationModal });
        }
    }

    toggleNoBuildingModal() {
        this.setState({ noBuildingModal: !this.state.noBuildingModal });
    }
    toggleConfirmationModal() {
        this.setState({ confirmationModal: !this.state.confirmationModal });
    }

    accordionHandler(id) {
        this.setState({ ...this.state, activeItems: id });
    }


    disableSendButton(setDisabled) {
        let sendButton = document.getElementById('sendFormBtn');
        if (sendButton) {
            (setDisabled) ? sendButton.setAttribute('disabled', true) : sendButton.removeAttribute('disabled');
        }
    }

    fillDotaznik() {
        this.disableSendButton(true);

        let step2 = this.getStep(2); // project doc
        let step3 = this.getStep(3); // coverings
        let extensions = this.getStep(4).data.values; // extensions
        let step5 = this.getStep(5); // gutters
        let step6 = this.getStep(6); // isolation
        let step7 = this.getStep(7); // contact form [objectPhoto for fileUpload]
        if (!this.state.extensions) extensions = {};

        var dotaznik = dotaznikJson;
        dotaznik.org = process.env.REACT_APP_ORG;
        dotaznik.dokumentace = this.state.documentation;
        dotaznik.datum = this.getCurrentDate();
        dotaznik.kontakt = step7.data.formData.kontakt;

        // SK: strip irrelevant address fields based on customer type
        if (process.env.REACT_APP_LANG === 'sk') {
            if (dotaznik.kontakt.typZadavatele === "Obchodník") {
                dotaznik.kontakt = { ...dotaznik.kontakt, obec: "", psc: "", ulice: "" };
            } else {
                dotaznik.kontakt = { ...dotaznik.kontakt, okres: "", stavebniny: "" };
            }
        }

        dotaznik.stavba = step7.data.formData.stavba;
        if (dotaznik.stavba.investor == "") {
            dotaznik.stavba.investor = dotaznik.kontakt.jmeno + " " + dotaznik.kontakt.prijmeni;
        }
        dotaznik.poznamka = step7.data.formData.stavba.poznamka;

        if (this.state.roofCalculation) {
            if (process.env.REACT_APP_LANG === 'sk') {
                dotaznik.sortiment = {
                    stdKrytina: step3.data.popularOnly,
                    krytiny: step3.data.dotaznikCoverings,
                    okapTyp: step5.data.chosenOkap?.model ?? null,
                    okapBarva: step5.data.chosenOkap?.barva ?? null,
                    rozsireni: {
                        protisnehovyHak: (extensions.item24) ? "A" : "N" || "N",
                        lemovani: (extensions.item21) ? "A" : "N" || "N",
                        okno: extensions.item14 || 0,
                        plosina40: extensions.item15 || 0,
                        kanalizace: extensions.item17 || 0,
                        sanita: extensions.item18 || 0,
                        antena: extensions.item19 || 0,
                        turbokotel: extensions.item20 || 0,
                        luminex44: extensions.item22 || 0,
                        luminex60: extensions.item23 || 0,
                    }
                }
            } else {
                dotaznik.sortiment = {
                    stdKrytina: step3.data.popularOnly,
                    krytiny: step3.data.dotaznikCoverings,
                    okapTyp: step5.data.chosenOkap?.model ?? null,
                    okapBarva: step5.data.chosenOkap?.barva ?? null,
                    rozsireni: {
                        protisnehovyHak: (extensions.item13) ? "A" : "N" || "N",
                        lemovani: (extensions.item9) ? "A" : "N" || "N",
                        hromosvod: (extensions.item10) ? "A" : "N" || "N",
                        okno: extensions.item1 || 0,
                        plosina40: extensions.item2 || 0,
                        kanalizace: extensions.item4 || 0,
                        sanita: extensions.item5 || 0,
                        antena: extensions.item6 || 0,
                        turbokotel: extensions.item7 || 0,
                        drzakAntena: extensions.item8 || 0,
                        luminex60: extensions.item12 || 0,
                    }
                }
            }
        }
        if (this.state.isolation) {
            dotaznik.izolace = { ...step6.data };
            dotaznik.izolace.izolaceTloustka = dotaznik.izolace.izolaceTyp + " " + dotaznik.izolace.izolaceTloustka;
            if (!dotaznik.izolace.rozpisPrvku) dotaznik.izolace.zatepleniPresahu = dotaznik.izolace.rozpisPrvku;
        }

        // Files
        let docFiles = [];
        if (step2.data.files != null) {
            docFiles = docFiles.concat([...step2.data.files]);
            dotaznik.bramac.zdroj = '016';
        }
        if (step7.data.objectImage != undefined) {
            step7.data.objectImage[0].typ = 'GPS';
            docFiles = docFiles.concat([...step7.data.objectImage]);
        }

        // Set files, then create Dotaznik
        this.setState({ files: docFiles },
            () => this.setState({ dotaznikValid: true },
                () => this.setState({ loadingModal: true }))
        );

    }
    sendDotaznik() {
        return ((this.state.dotaznikValid) ?
            <CreateDotaznik state={this.state} handler={this.dotaznikCreateHandler} />
            : <div></div>
        )
    }

    //callback function after create dotaznik API
    dotaznikCreateHandler(isCreated, message, responseMessage) {
        if (isCreated) {
            this.setState({ dotaznikCreated: true },
                () => this.setState({ loadingModalTitle: t("loading_success") },
                    () => this.setState({ loadingModalText: t("loading_redirect") })
                )
            );
            return;
        }
        this.disableSendButton(false);
        if (message == "notAuth" || (responseMessage.error != undefined && responseMessage.error == "Unauthorized")) {
            this.showInvalid("ErrorCreate", t("error_server"));
        } else if (typeof responseMessage === "string" && responseMessage.slice(0, 18) == "Nelze přiřadit PSČ") {
            this.showInvalid("pscKontakt", t("error_psc"));
        } else {
            this.showInvalid("ErrorCreate", t("error_send"));
        }

        this.setState({ dotaznikValid: false },
            () => this.setState({ loadingModal: false })
        );
    }

    getCurrentDate() {
        var currentdate = new Date();
        var datetime = currentdate.getFullYear() + '-'
            + (((currentdate.getMonth() + 1) < 10) ? "0" : "") + (currentdate.getMonth() + 1) + '-'
            + ((currentdate.getDate() < 10) ? "0" : "") + currentdate.getDate() + "T"
            + ((currentdate.getHours() < 10) ? "0" : "") + currentdate.getHours() + ":"
            + ((currentdate.getMinutes() < 10) ? "0" : "") + currentdate.getMinutes() + ":"
            + ((currentdate.getSeconds() < 10) ? "0" : "") + currentdate.getSeconds();
        return datetime;
    }



    validateAll() {
        if (this.state.dotaznikCreated) {
            this.showInvalid('alreadyCreated', t("error_form_already_sent"));
            return;
        }
        if (!this.state.roofCalculation && !this.state.isolation) {
            this.showInvalid("RoofCalculation", t("error_no_calc"));
            return;
        }
        if (!this.state.documentation && !this.state.noDocumentation) {
            this.showInvalid("HaveDocumentation", t("error_no_doc"));
            return;
        }

        if (this.state.documentation) {
            let docStep = this.getStep(2);
            if (docStep.data.files == undefined || docStep.data.fileSize == 0) {
                this.showInvalid("documentationFiles", t("error_upload_files"));
                return;
            } else if (docStep.data.fileSize >= 20000000) {
                this.showInvalid("documentationFiles", t("error_files_too_big"));
                return;
            }
        }

        if (this.state.roofCalculation) {
            let coveringStep = this.getStep(3);
            if (coveringStep.data == undefined
                || coveringStep.data.dotaznikCoverings == undefined
                || coveringStep.data.dotaznikCoverings.length == 0) {
                this.setState(
                    { ...this.state, activeItems: [3] },
                    () => this.showInvalid("popularCovering", t("error_no_covering"))
                );
                return;
            }

            let gutterStep = this.getStep(5);
            if (gutterStep.data.gutterCalc && (gutterStep.data.chosenOkap == null || gutterStep.data.chosenOkap == undefined)) {
                this.setState(
                    { ...this.state, activeItems: [5] },
                    () => this.showInvalid("gutterCalculation", t("error_gutter_no_match"))
                );
                return;
            }
        }

        if (this.state.isolation) {
            let isolationStep = this.getStep(6);
            if (isolationStep.data.izolaceTyp == "" || isolationStep.data.izolaceTloustka == "" ||
                isolationStep.data.izolaceTloustka <= 0 ||
                isolationStep.data == undefined || Object.keys(isolationStep.data).length < 1) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("isolationWidth", t("error_isolation_type"))
                );
                return;
            }

            if (!isolationStep.data.rozpisPrvku && !isolationStep.data.servisniPosouzeniTepelneOchrany) {
                this.setState(
                    { ...this.state, activeItems: [6] },
                    () => this.showInvalid("rozpisPrvku", t("error_isolation_options"))
                );
                return;
            }

            if (isolationStep.data.servisniPosouzeniTepelneOchrany == true) {
                if (isolationStep.data.osovaRoztecKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompPitch", t("error_enter_value"))
                    );
                    return;
                }
                if (isolationStep.data.sirkaKrokvi == "") {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("roofCompWidth", t("error_enter_value"))
                    );
                    return;
                }
                if (isolationStep.data.konstrukcniVrstvy.find(row => row.nazev != "") == undefined) {
                    this.setState(
                        { ...this.state, activeItems: [6] },
                        () => this.showInvalid("nazev", t("error_construction_layers"))
                    );
                    return;
                }
            }
        }

        this.setState({ activeItems: [7] });

        if (this.state.noDocumentation) {
            let addressInput = document.querySelector('div#mapAutocompleteDiv .geocoder-container input');
            if (addressInput && (addressInput.value === undefined || addressInput.value === "")) {
                addressInput.setCustomValidity(t("error_map_address"));
                addressInput.reportValidity();
                addressInput.setCustomValidity("");
                return;
            } else {
                addressInput.setCustomValidity("");
            }
        }

        if (!document.getElementById("kontaktForm").reportValidity()) {
            this.showInvalid("kontaktFormMessage", t("error_contact_form"));
            return;
        }
        let stavbaData = this.getStep(7).data.formData.stavba;
        let kontaktData = this.getStep(7).data.formData.kontakt;

        // SK: Obchodník must have a region selected
        if (process.env.REACT_APP_LANG === 'sk') {
            if (kontaktData.typZadavatele === "Obchodník" && (!kontaktData.okres || kontaktData.okres === "??")) {
                this.showInvalid("regions", t("error_region"));
                return;
            }
            if ((stavbaData.ulice == "" || stavbaData.obec == "" || stavbaData.psc == "") &&
                !(kontaktData.typZadavatele === "Realizační firma / pokrývač" || kontaktData.typZadavatele === "Obchodník")
            ) {
                this.showInvalid("buildingAddress", t("error_building_address"));
                return;
            }
        } else {
            if (stavbaData.ulice == "" || stavbaData.obec == "" || stavbaData.psc == "") {
                this.showInvalid("buildingAddress", t("error_building_address"));
                return;
            }
        }

        if (stavbaData.ulice.length > 200) {
            this.showInvalid("stavbaUlice",
                t("error_address_too_long_prefix") + stavbaData.ulice.length + t("error_address_too_long_suffix"));
            return;
        }

        if (!this.state.gdprConsent) {
            this.showInvalid("consentSwitch", t("error_gdpr"));
            return;
        }

        this.fillDotaznik();
    }

    getStep(num) {
        return this.state.steps.find(step => step.number == num);
    }

    showInvalid(elementId, message) {
        let element = document.getElementById(elementId);
        if (element != undefined) {
            element.setCustomValidity(message);
            element.reportValidity();
            element.setCustomValidity("");
        }
        {
            element = document.getElementById('validationMesage');
            let existingTextElement = document.getElementById('validationText')
            if (existingTextElement != undefined) {
                element.removeChild(existingTextElement);
            }
            let textElement = document.createElement('p');
            textElement.id = 'validationText';
            textElement.innerText = message;
            element.classList.remove('d-none');
            element.appendChild(textElement);
            setTimeout(() => {
                this.hideInvalid();
            }, 4500);
        }
    }
    hideInvalid() {
        let element = document.getElementById('validationMesage');
        element.classList.add('d-none');
        let validationText = document.getElementById('validationText')
        if (validationText) element.removeChild(validationText);
    }
    debugDiv() {
        return (process.env.REACT_APP_ENV === "dev" || process.env.REACT_APP_ENV === "localhost") ? (
            <div>
                React env - {process.env.NODE_ENV};
                Custom env - {process.env.REACT_APP_ENV};
                apiUrl - {process.env.REACT_APP_API_URL};
                {t("debug_only_test")}
            </div>
        ) : (<span></span>);
    }

    render() {
        this.stepsControl();
        const docUploadClass = (this.state.documentation) ? '' : 'd-none';

        return (
            <div className="App">
                <Login />
                {this.debugDiv()}

                <div key='InitialStep' className='mt-4 rootContainer m-auto'>
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol size='12' md='8' lg='9' className=''>
                                <h2 className='text-uppercase c-primary'>{t("page_title")}</h2>
                            </MDBCol>
                            <MDBCol size='12' md='4' lg='3' className='d-flex justify-content-md-end'>
                                <MDBBtn color='link' rippleColor='light' size='lg' href={this.state.config.linkCenik} className='text-decoration-underline c-primary px-0' target='_blank'>
                                    {t("pricelist_link")}
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className='mb-5 planeBackground' style={{
                        backgroundImage: "url(" + BG_IMG_PLANE + "),url(" + BG_IMG_CLOUDS + ")"
                    }}>
                        <MDBRow>
                            <MDBCol size='6' className="mt-5">
                                <p>
                                    {t("help_text")}
                                </p>
                                <MDBBtn color='link' rippleColor='light' size='lg' className='text-decoration-underline p-0 c-primary'
                                    href={this.state.config.linkOblastniZastupce} target='_blank'>
                                    {t("contact_link")}
                                </MDBBtn>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-5">
                            <MDBRow className='mt-3 align-items-end'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.roofCalculation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('RoofCalculation').click(); }}>
                                        {t("roof_calc_switch")}
                                    </p>
                                    <MDBValidationItem className='' invalid feedback='Example invalid feedback text.'>
                                        <MDBSwitch id='RoofCalculation' name='roofCalculation'
                                            wrapperClass="d-grid justify-content-center" defaultChecked={this.state.roofCalculation}
                                            onClick={(e) => { this.setState({ roofCalculation: e.target.checked }) }} />
                                    </MDBValidationItem>
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.isolation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={(e) => { document.getElementById('Isolation').click(); }}>
                                        {t("isolation_switch")}
                                    </p>
                                    <MDBSwitch id='Isolation' name='isolation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.isolation}
                                        onClick={(e) => {
                                            this.setState({ isolation: e.target.checked },
                                                this.accordionHandler(6))
                                        }} />
                                </MDBCol>
                            </MDBRow>

                        </MDBRow>
                        <MDBRow className="mt-3">
                            <MDBCol xl="11" md='11' sm="12">
                                <p>
                                    {t("doc_description")}
                                </p>
                            </MDBCol>
                            <MDBRow className='mt-3'>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.documentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('HaveDocumentation').click(); }}>
                                        {t("have_doc_switch")}
                                    </p>
                                    <MDBSwitch id='HaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.documentation}
                                        onClick={(e) => {
                                            this.setState(
                                                { documentation: e.target.checked },
                                                () => this.handleDocumentation(e))
                                        }} />
                                </MDBCol>
                                <MDBCol xl='6' md='5' sm="12" className={CONSTANTS.FIRST_PAGE_SWITCH_TEXT_CLASSES + primaryColorByBool(this.state.noDocumentation)} >
                                    <p className='text-center text-uppercase h-100 mb-1' onClick={() => { document.getElementById('DontHaveDocumentation').click(); }}>
                                        {t("no_doc_switch")}
                                    </p>
                                    <MDBSwitch id='DontHaveDocumentation' name='documentation'
                                        wrapperClass="d-grid justify-content-center" defaultChecked={this.state.noDocumentation}
                                        onClick={(e) => {
                                            this.setState({ noDocumentation: e.target.checked },
                                                () => {
                                                    this.toggleNoDocModal();
                                                    this.handleDocumentation(e);
                                                })
                                        }} />
                                </MDBCol>
                            </MDBRow>

                            <div key='NoDocumentationModals'>
                                <MDBModal staticBackdrop open={this.state.noDocumentationModal} tabIndex='-1'>
                                    <MDBModalDialog centered size='lg'>
                                        <MDBModalContent className='p-2'>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>{t("no_doc_modal_title")}</MDBModalTitle>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                <p>{t("no_doc_modal_body1")}</p>
                                                <p>
                                                    {t("no_doc_modal_body2")}
                                                    <b> {t("no_doc_modal_body2b")}</b>
                                                </p>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => this.setState({ buildingExists: true }, this.toggleNoDocModal())}>
                                                    {t("no_doc_modal_btn_yes")}
                                                </MDBBtn>
                                                <MDBBtn color='primary' className='mx-auto fs-6 px-5 no-doc-modal-btn' onClick={() => { this.toggleNoDocModal(); this.toggleNoBuildingModal(); }}>
                                                    {t("no_doc_modal_btn_no")}
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                                <MDBModal staticBackdrop open={this.state.noBuildingModal} tabIndex='-1'>
                                    <MDBModalDialog centered>
                                        <MDBModalContent>
                                            <MDBModalHeader>
                                                <MDBModalTitle className='text-uppercase'>Pozor!</MDBModalTitle>
                                                <MDBBtn className='btn-close' color='none' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}></MDBBtn>
                                            </MDBModalHeader>
                                            <MDBModalBody>
                                                {t("no_building_modal_body")}
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => {
                                                    this.toggleNoBuildingModal();
                                                    document.getElementById('DontHaveDocumentation').click();
                                                }}>
                                                    {t("no_building_modal_btn")}
                                                </MDBBtn>
                                            </MDBModalFooter>
                                        </MDBModalContent>
                                    </MDBModalDialog>
                                </MDBModal>
                            </div>
                        </MDBRow>
                    </MDBContainer>

                    <MDBContainer className={docUploadClass}>
                        <Step key={"step2"} step={this.state.steps.find(step => step.number == 2)} handler={this.stepsHandler} />
                    </MDBContainer>

                    <MDBContainer>
                        <MDBAccordion flush alwaysOpen active={this.state.activeItems} onChange={(itemId) => this.accordionHandler(itemId)}>
                            {this.state.steps.map(step => {
                                return (step.accStep) ? (
                                    <MDBAccordionItem collapseId={step.number} headerTitle={step.header} key={'step' + step.number} className={step.visibleClass}>
                                        <MDBContainer>
                                            <Step step={step} handler={this.stepsHandler} stateHandler={this.stateHandler} selectedCoveringColor={this.state.selectedCoveringColor} />
                                        </MDBContainer>
                                    </MDBAccordionItem>
                                ) : (
                                    <div key={"nstep" + step.number}></div>
                                )

                            })}
                        </MDBAccordion>
                    </MDBContainer>

                    <MDBContainer className='mt-5 d-flex justify-content-center align-items-center'>
                        <MDBSwitch id='consentSwitch' name='consent'
                            onClick={(e) => { this.setState({ gdprConsent: e.target.checked }) }} />
                        <MDBBtn color='link' rippleColor='light' className='content-link ms-1 px-1' onClick={() => { this.setState({ gdprModal: true }) }}>
                            {t("gdpr_link")}
                        </MDBBtn>

                        <MDBModal open={this.state.gdprModal} tabIndex='-1' onClose={() => this.setState({ gdprModal: false })}>
                            <MDBModalDialog scrollable size='xl'>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>{t("gdpr_modal_title")}</MDBModalTitle>
                                        <MDBBtn className='btn-close' color='none' onClick={() => this.setState({ gdprModal: false })}></MDBBtn>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <Step step={this.state.steps.find(step => step.number == 8)} handler={this.stepsHandler} stateHandler={this.stateHandler} />
                                    </MDBModalBody>
                                    <MDBModalFooter>
                                        <MDBBtn color='primary' className='mx-auto fs-6' onClick={() => this.setState({ gdprModal: false })}>
                                            {t("gdpr_modal_btn")}
                                        </MDBBtn>
                                    </MDBModalFooter>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>

                    <MDBContainer className="d-grid my-4 text-center">
                        <div id='validationMesage' className='validation-msg d-none fs-5' onClick={() => this.hideInvalid()}>
                            <MDBBtn className='btn-close float-end ms-3' color='none'></MDBBtn>
                        </div>
                        <button id='sendFormBtn' className="btn btn-primary btn-lg fs-5 fw-bold"
                            onClick={() => this.validateAll()} disabled={!this.state.gdprConsent}>
                            {t("send_btn")}
                        </button>
                        <MDBModal staticBackdrop open={this.state.loadingModal} tabIndex='-1' >
                            <MDBModalDialog centered>
                                <MDBModalContent className='p-2'>
                                    <MDBModalHeader>
                                        <MDBModalTitle className='text-uppercase'>{this.state.loadingModalTitle}</MDBModalTitle>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <p>{this.state.loadingModalText}</p>
                                    </MDBModalBody>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>
                    </MDBContainer>

                </div>
                {this.sendDotaznik()}

                <BmiCookieConsent />
            </div>
        );
    }
}

export default PriceCalculatorForm;


function primaryColorByBool(value) {
    return value ? ' c-primary ' : ' ';
}
